import { createSelector } from "reselect";
import type { RootState } from "single-spa/store/types";
import { selectOpportunityLists } from "../../opportunities/store/selectors";
import { OpportunityListTypeEnum } from "../../opportunities/types";

export const selectDisabledListNames = createSelector(
    selectOpportunityLists,
    (_state: RootState, props: { domain: string }) => props.domain,
    (opportunityLists, domain) => {
        return opportunityLists.reduce<string[]>((acc, list) => {
            const isWebsiteInList = list.opportunities.includes(domain);
            if (isWebsiteInList || list.listType === OpportunityListTypeEnum.RecentlyViewed) {
                acc.push(list.opportunityListId);
            }
            return acc;
        }, []);
    },
);

export const selectOpportunityListsWithoutRecentlyViewed = createSelector(selectOpportunityLists, (opportunityLists) =>
    opportunityLists.filter((v) => v.listType !== OpportunityListTypeEnum.RecentlyViewed),
);

export const selectAlreadyInList = createSelector(
    selectOpportunityListsWithoutRecentlyViewed,
    (_state: RootState, props: { domain: string }) => props.domain,
    (opportunityLists, domain) =>
        opportunityLists.reduce<string[]>((acum, { opportunities, friendlyName }) => {
            const present = opportunities.includes(domain);

            if (!present) {
                return acum;
            }

            return [...acum, friendlyName];
        }, []),
);
